app.initializers.add('zerosonesfun/flarum-inline-audio', () => {
  return;
});